import React from 'react';
import { Breadcrumb, Segment } from 'semantic-ui-react';
import './FilAriane.css';

function linkHomepage() {
  window.location = '/';
}

const FilAriane = () => (
  <Segment id="filAriane">
    <Breadcrumb icon="right angle">
      <Breadcrumb.Section onClick={linkHomepage}> Accueil  </Breadcrumb.Section>
      <Breadcrumb.Divider>&gt;</Breadcrumb.Divider>
      <Breadcrumb.Section>Votre projet </Breadcrumb.Section>
    </Breadcrumb>
  </Segment>
);


export default FilAriane;



// WEBPACK FOOTER //
// ./src/components/shared/FilAriane.js